module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "text-xs-center": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.isUpdateValid),
      callback: function($$v) {
        _vm.isUpdateValid = $$v
      },
      expression: "isUpdateValid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Name:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Factory Name",
      "rules": _vm.nameRules,
      "solo": "",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.objFactoryEdit.name),
      callback: function($$v) {
        _vm.$set(_vm.objFactoryEdit, "name", $$v)
      },
      expression: "objFactoryEdit.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Description:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Factory Description",
      "rules": _vm.descriptionRules,
      "solo": "",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.objFactoryEdit.description),
      callback: function($$v) {
        _vm.$set(_vm.objFactoryEdit, "description", $$v)
      },
      expression: "objFactoryEdit.description"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Address:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Address",
      "rules": _vm.addressRules,
      "solo": "",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.objFactoryEdit.address),
      callback: function($$v) {
        _vm.$set(_vm.objFactoryEdit, "address", $$v)
      },
      expression: "objFactoryEdit.address"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-2 pt-2 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.runEdit) ? _c('v-progress-circular', {
    staticClass: "pt-3 loginLoader",
    attrs: {
      "indeterminate": "",
      "width": 3,
      "size": 20,
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.runEdit) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": !_vm.isUpdateValid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncUpdateFactory()
      }
    }
  }, [_vm._v("Update")]) : _vm._e(), _vm._v(" "), _c('small', [_vm._v("* The button will activate once all required fields have been completed")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}